export class OrderClaimRequest {
    orderDate?: Date;
    serial?: string;
    orderNumber?: number;
}